export default __webpack_public_path__ + "static/media/ic_edit.f1475621.svg";